module.exports = __webpack_public_path__ + "img/trams.1e06e0af.jpeg";